import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { actionCreators as selfServiceActions } from "../redux/actions/selfServiceActions";
import LinearProgress from "@material-ui/core/LinearProgress";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { NavLink } from "react-router-dom";
import "./self-service.css";
import * as routeHelpers from "../authentication/routeHelpers";
import { withStyles } from "@material-ui/core/styles";
import * as settings from "../shared/settingsConstants"

class EntityMenu extends React.Component {
  render() {
    return (
      <>
        {this.props.isLoading ? (
          <LinearProgress />
        ) : (
          <>
            {!this.props.accountMismatch && this.props.entities.map((entity) => (
              <div key={entity.EntityChangeRequestID}>
                <ListItem
                  component={NavLink}
                  to={routeHelpers.buildRoute(`/entities/${entity.EntityChangeRequestID}`)}
                  button
                  activeClassName={this.props.classes.activeEntity}
                >
                  <ListItemText
                    primary={entity.EntityName}
                    className="list-item-text"
                  />
                </ListItem>
              </div>
            ))}
          </>
        )}
      </>
    );
  }
}

const styles = (theme) => ({
  activeEntity: {
    backgroundColor: `${
      theme.palette.custom
        ? theme.palette.custom.drawerActiveBackground
        : settings.portalSettings.drawerActiveBackground
    } !important`,
  },
});

export default compose(
  withStyles(styles),
  connect(
    (state) => Object.assign({}, state.selfService, state.authentication),
    (dispatch) => bindActionCreators(selfServiceActions, dispatch)
  )
)(EntityMenu);
